<template>
  <div class="integration-config skeleton-add-integration">
    <div class="integration-config-card ">
      <div class="skeleton-feature-loading">
        <div class="tree-node-component skeleton-feature">
          <div class="skeleton-line" style="width: 60%;"></div>
        </div>
        <div class="tree-node-component skeleton-feature">
          <div class="skeleton-line"  style="width: 40%;"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'IntegrationSkeletonComponent'
})
</script>

<style lang="scss" scoped>
.skeleton-feature-loading{
  margin: var(--space-0) !important;
  .skeleton-feature{
    height: 20px !important;
  }
}
</style>
